// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonCreateLabel {
  display: flex;
  font-size: 1.26rem;
}

.countrycode-virtualScroller::-webkit-scrollbar {
  display: none !important;
}

.MuiDataGrid-virtualScroller::-webkit-scrollbar {
  display: none !important;
}

.MuiDataGrid-virtualScroller {
  max-height: 870px;
  overflow-y: scroll;
  width: 100%;
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

.MuiDataGrid-virtualScroller::-webkiZt-scrollbar {
  display: none !important;
}

.actionSection {
  display: flex;
  margin: 0px 10px 0px 0px;
}
.actionSection .commonActionItem, .actionSection .commonActionItemEnd {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 15px 0px 15px;
}
.actionSection .commonActionItemEnd {
  display: grid;
  margin-left: auto;
}

.refextSection {
  display: flex;
}

.refextSectionSDocumentNr {
  display: flex;
}

.refTextField {
  display: flex;
  flex: 0 0 92%;
  align-content: center;
}

.headerTextField {
  display: flex;
  flex: 0 0 92%;
  align-content: center;
}

.refTextFieldTemplateRight {
  display: flex;
  flex: 0 0 30%;
  align-items: center;
  justify-content: center;
}

.refTextFieldStartDocumentNr {
  display: flex;
  flex: 0 0 46%;
  justify-content: space-between;
}

.refTextFieldVerbuchung {
  display: flex;
  flex: 0 0 100%;
  justify-content: flex-start;
}

.refTextFieldTemplate {
  display: flex;
  flex: 0 0 70%;
}

.rightTextFieldStartDocumentNr {
  display: flex;
  flex: 0 0 52%;
  justify-content: flex-end;
  margin-left: 15px;
}

.rightTextFieldAufwandskonto {
  display: flex;
  flex: 1 0 35%;
  justify-content: flex-end;
  margin-left: 10px;
}

.actionSectionRight {
  display: flex;
  margin: 0px 10px 0px 0px;
}
.actionSectionRight .commonActionItem {
  display: grid;
}

.commonactionRight {
  display: flex;
  flex: 1 0 50%;
}

.searchInvoiceDiv {
  display: flex;
  flex: 1 0 50%;
  justify-content: flex-end;
}

.setMarginLeft {
  margin-left: 25px;
}

.leftSection {
  padding: 5px 15px;
  border-radius: 5px;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/features/Templates/template.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;AACJ;;AAEA;EACI,wBAAA;AACJ;;AACE;EACE,wBAAA;AAEJ;;AAAE;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,gCAAA;EACA,mCAAA;AAGJ;;AADE;EACE,wBAAA;AAIJ;;AADA;EACI,aAAA;EACA,wBAAA;AAIJ;AAFI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;AAIR;AAFI;EACI,aAAA;EAEA,iBAAA;AAGR;;AAAA;EACI,aAAA;AAGJ;;AADA;EACI,aAAA;AAIJ;;AAFA;EACI,aAAA;EACA,aAAA;EACA,qBAAA;AAKJ;;AAHA;EACI,aAAA;EACA,aAAA;EACA,qBAAA;AAMJ;;AAHA;EAEK,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAKL;;AADA;EAEI,aAAA;EACA,aAAA;EACA,8BAAA;AAGJ;;AAEA;EAEI,aAAA;EACA,cAAA;EACA,2BAAA;AAAJ;;AAKA;EACI,aAAA;EACA,aAAA;AAFJ;;AAKA;EACI,aAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;AAFJ;;AA0CA;EACI,aAAA;EACA,wBAAA;AAvCJ;AAwCI;EACI,aAAA;AAtCR;;AAyCA;EACI,aAAA;EACA,aAAA;AAtCJ;;AAwCA;EACI,aAAA;EACA,aAAA;EACA,yBAAA;AArCJ;;AAuCA;EACI,iBAAA;AApCJ;;AAoDA;EACI,iBAAA;EAEA,kBAAA;EACA,gBAAA;AAlDJ","sourcesContent":[".commonCreateLabel {\n    display: flex;\n    font-size: 1.26rem;\n}\n\n.countrycode-virtualScroller::-webkit-scrollbar {\n    display: none !important;\n  }\n  .MuiDataGrid-virtualScroller::-webkit-scrollbar {\n    display: none !important;\n  }\n  .MuiDataGrid-virtualScroller {\n    max-height: 870px;\n    overflow-y: scroll;\n    width: 100%;\n    scrollbar-width: none !important;\n    -ms-overflow-style: none !important;\n  }\n  .MuiDataGrid-virtualScroller::-webkiZt-scrollbar {\n    display: none !important;\n  }\n\n.actionSection{\n    display: flex;\n    margin: 0px 10px 0px 0px;\n    // justify-content: space-between;\n    .commonActionItem,.commonActionItemEnd{\n        display: flex;    \n        flex-direction: column;\n        align-items: center;\n        padding: 0px 15px 0px 15px;\n    }\n    .commonActionItemEnd{\n        display: grid;\n        // padding: 0px 15px 0px 15px;\n        margin-left: auto;\n    }\n}\n.refextSection{\n    display: flex;\n}\n.refextSectionSDocumentNr{\n    display: flex;\n}\n.refTextField{\n    display: flex;\n    flex: 0 0 92%;  \n    align-content: center; \n}\n.headerTextField{\n    display: flex;\n    flex: 0 0 92%;  \n    align-content: center; \n}\n\n.refTextFieldTemplateRight{\n    // position: relative;\n     display: flex;\n     flex: 0 0 30%;  \n     align-items: center;\n     justify-content: center;\n\n}\n\n.refTextFieldStartDocumentNr{\n    // position: relative;\n    display: flex;\n    flex: 0 0 46%;  \n    justify-content: space-between;\n    // align-content: center;\n    // justify-content: flex-end;\n}\n\n.refTextFieldVerbuchung{\n    // position: relative;\n    display: flex;\n    flex: 0 0 100%;  \n    justify-content:flex-start;\n    // align-content: center;\n    // justify-content: flex-end;\n}\n\n.refTextFieldTemplate{\n    display: flex;\n    flex: 0 0 70%;  \n    // align-content: center; \n}\n.rightTextFieldStartDocumentNr{\n    display: flex;\n    flex: 0 0 52%;  \n    justify-content: flex-end;\n    margin-left: 15px;\n}\n\n.rightTextFieldAufwandskonto{\n    display: flex;\n    flex: 1 0 35%;  \n    justify-content: flex-end;\n    margin-left: 10px;\n}\n\n// .btnAdd{\n//     display: flex;\n//     flex: 0 0 100%;\n//     margin-top: 10px;\n//     justify-content: center;\n// }\n// .refTextFieldPrefix{\n//     display: flex;\n//     flex: 0 0 60%;\n// }\n// .refTextFieldErtragskonto{\n//     display: flex;\n//     flex: 1 0 35%;\n// }\n// .setDisplay{\n//     display: flex;\n//     .refFieldDiv,.currencyDiv{\n//         display: flex;\n//         flex: 1 0 45%;\n//         padding-right: 5px;\n//     }\n//     .custRefFieldDiv,.invoicedateDiv{\n//         display: flex;\n//         flex: 1 0 45%;\n//         padding-left: 5px;\n//     }\n// }\n// .typeDivTemplate{\n//     display: flex;\n//     flex: 1 0 45%;\n//     // padding-right: 5px;\n// }\n// .textAreaDiv{\n//     display: flex;\n//     flex: 1 0 45%;\n//     padding-left: 5px;\n// }\n.actionSectionRight{\n    display: flex;\n    margin: 0px 10px 0px 0px; \n    .commonActionItem{\n        display: grid;\n    }\n}\n.commonactionRight{\n    display: flex;\n    flex: 1 0 50%;\n}\n.searchInvoiceDiv{\n    display: flex;\n    flex: 1 0 50%;\n    justify-content: flex-end;\n}\n.setMarginLeft{\n    margin-left: 25px;\n}\n\n// .footerSectionArea{\n//     display: flex;\n// }\n// .footerFieldDiv{\n//     display: flex;\n//     flex: 0 0 60%;\n// }\n// .amountDivSection{\n//     display:flex;\n//     flex: 0 0 40%;\n//     justify-content: space-between;\n// }\n\n.leftSection{\n    padding: 5px 15px;\n    // border: 1px solid #333!important;\n    border-radius: 5px;\n    margin-top: 10px;\n    // height: 725px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
